
const authentication = require('../../../react-azure-adb2c2').default;
export const download = (values: any) => {
    // const url = process.env.REACT_APP_API_CRM_URL + `/api/v1/rent/contract/follows/list`;
    // const url = `http://localhost:5000/v1/rent/application/docs/download/` + values;
    const url = process.env.REACT_APP_API_CRM_URL + `/v1/rent/application/docs/download/` + values
    //
    // alert(url)
    const token = authentication.getAccessToken();
    //const search = values ? values : {};
    // alert(JSON.stringify(values))

    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token },

    }).then(res => res.blob())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

}

